import ButtonProps from './types';
import StyledButton from './styled/Button.styled';
/**
* A button allows us to highlight actions in the product and make them easily perceived and achievable through just one click.
*/
const Button = ({
  color = 'primary',
  variant = 'contained',
  size = 'medium',
  shape = 'rounded',
  textTransform = 'capitalize',
  children,
  noOutline = true,
  useDynamicColor = false,
  onClick = () => {},
  ...props
}: Partial<ButtonProps>) => (
  <StyledButton
    color={color}
    variant={variant}
    size={size}
    shape={shape}
    textTransform={textTransform}
    useDynamicColor={useDynamicColor}
    onClick={onClick}
    noOutline={noOutline}
    {...props}
  >
    {children}
  </StyledButton>
);

export default Button;
